import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetIndividualBookingCapQuery } from '../../../app/Slices/SevenDayApiSlice';
import { CustomButton } from '../../../layout/styledcomponents/CustomButton';
import LoadingComponent from '../../../layout/styledcomponents/LoadingAnimations/LoadingComponent';
import BookingCapForm from '../../components/BookingCaps/BookingCapForm';

const EditBookingCapPage = () => {
    const isMobile = useMediaQuery('(max-width: 770px)');
    const isIpad = useMediaQuery('(max-width: 1200px)');
    const [url, setUrl] = useState('');
    const { data: getIndividualBookingCap, isFetching } =
        useGetIndividualBookingCapQuery(url);
    const urlRef = window.location.href.split('/')[4];
    const navigate = useNavigate();
    const theme = useTheme();

    useEffect(() => {
        if (urlRef !== undefined) {
            setUrl(`/booking-caps/${urlRef}`);
        }
    }, []);

    const handleBackButton = () => {
        navigate(`/bookingCaps`);
    };

    return (
        <>
            {isFetching === true ? (
                <Grid
                    sx={{
                        height: '100%',
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        alignContent: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <LoadingComponent />
                </Grid>
            ) : (
                <Grid
                    sx={{
                        width: '100%',
                        height: isMobile ? '100%' : '95%',
                        justifyContent: 'left',
                        alignItems: 'center',
                    }}
                >
                    <BookingCapForm capProp={getIndividualBookingCap} />
                    <CustomButton
                        onClick={handleBackButton}
                        color='primary'
                        sx={{
                            marginLeft: '-18px',
                            display: isMobile || isIpad ? 'none' : 'flex', // Hide on mobile
                            '&:hover': {
                                cursor: 'pointer',
                                color: theme.palette.textAccent.main,
                                backgroundColor: 'transparent',
                                background: 'none',
                            },
                        }}
                    >
                        <ArrowBackIcon />{' '}
                        <Typography
                            sx={{
                                fontSize: '12px',
                                paddingLeft: '5px',
                            }}
                        >
                            Back to list
                        </Typography>
                    </CustomButton>
                </Grid>
            )}
        </>
    );
};

export default EditBookingCapPage;
